/**
 * Get local storage item
 * @param {string} item local storage key
 * @returns {any} local storage value
 */
export function getLocalStorageItem(item) {
    try {
        let storageVal = window.localStorage.getItem(item);
        console.log(`${item} is ${storageVal}`);

        // empty key
        if (storageVal === null) return null;

        // try parse
        try {
            return JSON.parse(storageVal);
        } catch {
            return storageVal;
        }
    } catch(error) {
        console.error(error);
        return undefined;
    }
}

/**
 * checks if a string (when JSON parsed) is an object.
 * helper to getLocalStorageItem
 * @param {string} str 
 * @returns {boolean} true if object or array, else false
 */
export function isJsonStringObj(str) {
    try {
        let parsed = JSON.parse(str);
        // Check if parsed result is an object or array
        return typeof parsed === "object" && parsed !== null;
    } catch (e) {
        // If an error is thrown, it's not valid JSON
        return false;
    }
}

/**
 * Update local storage item
 * @param {string} item local storage key
 * @param {any} value local storage value
 */
export function updateLocalStorageItem(item, value) {
    try {
        window.localStorage.setItem(item, ensureJSONString(value));
        console.log(`${item} is now ${value}`);
    } catch(error) {
        console.error(error);
    } finally {
        return;
    }
}

/**
 * ensures value is a string and converts it to one if not.
 * helper to updateLocalStorageItem
 * @param {any} value anything
 * @returns 
 */
export function ensureJSONString(value) {
    return typeof value === 'string' ? value : JSON.stringify(value);
}

/**
 * will create the new sub-property if doesn't currently exist in pageInfo
 * @param {string} property path starting inside pageInfo item (eg. "fruits.apple")
 * @param {any} value set property to this value
 */
export function updatePageInfo(property, value) {
    try {
        let pageInfoCurrent = getLocalStorageItem("pageInfo");
        if (pageInfoCurrent == undefined) { // no pageInfo, so make it
            pageInfoCurrent = {};
        }
        
        // Update the nested property
        setNestedProperty(pageInfoCurrent, property, value);
        updateLocalStorageItem("pageInfo", pageInfoCurrent);
    } catch(error) {
        console.error(error);
    } finally {
        return;
    }
}

/**
 * update nested properties.
 * helper to updatePageInfo
 * @param {object} obj object to update
 * @param {string} path path starting inside obj (eg. "fruits.apple")
 * @param {any} value set path to this value
 * @returns 
 */
export function setNestedProperty(obj, path, value) {
    try {
        const keys = path.split('.');
        let current = obj;
    
        for (let i = 0; i < keys.length - 1; i++) {
            if (!current[keys[i]]) {
                current[keys[i]] = {}; // Create nested object if it doesn't exist
            }
            current = current[keys[i]];
        }
    
        current[keys[keys.length - 1]] = value;
    } catch(error) {
        console.error(error);
    } finally {
        return;
    }
}

/**
 * updates pageInfo local storage redirects
 * @returns {boolean} true
 */
export async function updatePageInfoRedirects(redirectPaths) {
    // get the old links
    let currentPI = getLocalStorageItem("pageInfo") ?? {},
        currentRedirects = currentPI.redirects ?? {},
        currentURL = window.location.pathname + window.location.search + window.location.hash,
        
        // previous URLs shift to become candiates for this page
        candidateLast = currentRedirects.currentPageURL ?? ``,
        previousLast = currentRedirects.lastPageURL ?? ``;

    console.log(`currentRedirects are: `, currentRedirects);

    // check special cases
    // if no last page
    if (!candidateLast ) {
        candidateLast = previousLast || redirectPaths.auth.redirectLogin;
    }
    // if page has been reloaded (or immediately revisited)
    if (candidateLast === currentURL) {
        // if a previous one exists and is different
        if (previousLast && previousLast != currentURL) {
            candidateLast = previousLast;
        } else { // if all redirects are the same page as current page
            candidateLast = redirectPaths.auth.redirectLogin; 
        }
    }

    console.log(`candidateLast is: `, candidateLast);

    // construct redirects sub-obj
    let newRedirects = {
        lastPageURL: candidateLast,
        currentPageURL: currentURL,
    };

    // update pageInfo
    updatePageInfo("redirects", newRedirects);

    return true;
}